const toMediaQuery = require('./utilities/toMediaQuery');

class Breakpoint {
  constructor(key, { max, min }) {
    this.key = key;
    this.max = max;
    this.min = min;
    this.mediaQuery = toMediaQuery(this);
  }
}

const breakpoints = {
  xl: new Breakpoint('xl', { min: 1200 }),
  xs: new Breakpoint('xs', { max: 1199 }),
  xxxl: new Breakpoint('xxxl', { min: 1900 }),
};

module.exports = breakpoints;
